import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/zona-de-salario-minimo';

/**
 * GET Zona de salario minimo
 * @returns {Promise<object[]>}
 */
export const getZonasDeSalariosMinimos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Zona de salario minimo
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getZonaDeSalarioMinimo = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Zona de salario minimo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postZonaDeSalarioMinimo = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Zona de salario minimo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchZonaDeSalarioMinimo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Zona de salario minimo
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteZonaDeSalarioMinimo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
